import React from "react"
import { Box, useMediaQuery, useTheme } from "@material-ui/core"
import useStore from "src/v2/utils/store"
import AskAIChat from "./ask-ai-chat"
import FileViewer from "./file-viewer/file-viewer"

export default function AskAI() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const oneReview = useStore((state) => state.oneReview)
  const solFiles = oneReview?.analyzedData?.solFiles || []
  const initialFile = oneReview?.mainFileName || (solFiles[0]?.path || "")

  if (!oneReview) {
    return <Box p={2}>Loading...</Box>
  }

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      width="100%"
      height="100%"
      minHeight={isMobile ? 600 : 400}
      style={{ background: "#f6f6fa" }}
    >
      <Box
        flex={isMobile ? "unset" : 1}
        width={isMobile ? "100%" : "50%"}
        minWidth={isMobile ? "100%" : 0}
        style={{
          borderRight: isMobile ? "none" : "1px solid #eee",
          borderBottom: isMobile ? "1px solid #eee" : "none",
          background: "#fff",
          minHeight: 300,
        }}
      >
        <AskAIChat />
      </Box>
      <Box
        flex={isMobile ? "unset" : 1}
        width={isMobile ? "100%" : "50%"}
        minWidth={isMobile ? "100%" : 0}
        style={{
          background: "#f6f6fa",
          minHeight: 300,
        }}
      >
        <FileViewer solFiles={solFiles} initialFile={initialFile} />
      </Box>
    </Box>
  )
}
